import * as React from 'react';
import { Input as FluentInput, type InputProps as FluentInputProps } from '@fluentui/react-components';

export type InputProps = Omit<FluentInputProps, 'size'> & {
  size?: 'default' | 'sm' | 'lg';
};

function mapSize(size?: InputProps['size']): FluentInputProps['size'] {
  switch (size) {
    case 'sm':
      return 'small';
    case 'lg':
      return 'large';
    case 'default':
    default:
      return 'medium';
  }
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ size = 'default', className, ...rest }, ref) => {
    return (
      <FluentInput
        size={mapSize(size)}
        className={className}
        ref={ref}
        {...rest}
      />
    );
  }
);

Input.displayName = 'Input';


